import { render } from "./OrderDetailHeader.vue?vue&type=template&id=63979bee"
import script from "./OrderDetailHeader.vue?vue&type=script&lang=js"
export * from "./OrderDetailHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__